/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "loading-label": [{
    "type": 0,
    "value": "Loading"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var enSG = Object.assign(TranslationProviderComponent, {
  translations
});

export { enSG as e };
//# sourceMappingURL=en-SG-CNYbylKY.js.map
